import { render, staticRenderFns } from "./StepSupervisorAssignment.vue?vue&type=template&id=b0f0dc1c&scoped=true&"
import script from "./StepSupervisorAssignment.vue?vue&type=script&lang=js&"
export * from "./StepSupervisorAssignment.vue?vue&type=script&lang=js&"
import style0 from "./StepSupervisorAssignment.vue?vue&type=style&index=0&id=b0f0dc1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f0dc1c",
  null
  
)

export default component.exports